// Pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';



const NotFound = () => {
  return (
    <NotFoundContainer>
      <NotFoundTitle>404</NotFoundTitle>
      <NotFoundMessage>Lo sentimos, la página que estás buscando no existe.</NotFoundMessage>
      <NotFoundButton to="/">Volver al Inicio</NotFoundButton>
    </NotFoundContainer>
  );
}

export default NotFound;
const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background-color: #f0f0f0;
  width:100vw;
`;

const NotFoundTitle = styled.h1`
  font-size: 6rem;
  font-weight: bold;
  color: #ff6b6b;
  margin-bottom: 20px;
`;

const NotFoundMessage = styled.p`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 30px;
`;

const NotFoundButton = styled(Link)`
  padding: 10px 20px;
  font-size: 1.2rem;
  color: white;
  background-color: #ff6b6b;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ff4757;
  }
`;